import React, {useEffect, useState, useRef} from 'react';
import {useTranslation} from 'react-i18next';
import {responseInterceptor} from '../api/axios';
import useCookie from "../hooks/useCookie";
import ChatWindow from '../components/chat/ChatWindow';
import SourceText from '../components/chat/SourceText';
import {Grid, TextField} from "@mui/material";
import Chapters from "../components/chat/Chapters";
import {useTabsAtom} from "../atoms/useTabsAtom";
import {useSelectedTabAtom} from "../atoms/useSelectedTabAtom";
import {IntentEnum} from "../enums/IntentEnum";
import CompareNorms from "../components/chat/CompareNorms";
import {compareNorms} from "../api/questionAPIs";
import { comparedTextAtom } from "../atoms/useComparedTextAtom";
import { useAtom } from 'jotai';
import LoadingScreen from '../components/shared/LoadingScreen';

const Page = () => {
    const [t,] = useTranslation('global');
    const [, i18n] = useTranslation('global');
    const [ulaCookie, setCookie] = useCookie("ULA");
    const [selectedTab, setSelectedTab] = useSelectedTabAtom();
    const [isLoading, setIsLoading] = useState(false);
    const [sourceText, setSourceText] = useState('');
    const [selectedChapter, setSelectedChapter] = useState(null);
    const [compareResult, setCompareResult] = useState(null);
    const [compareSourceText, setCompareSourceText] = useState('');
    const [comparedText, setComparedText] = useAtom(comparedTextAtom);
    const bottomRef = React.useRef();

    useEffect(() => {
        setLanguage();
        setIsLoading(false);
        responseInterceptor();
    }, []);

    const setLanguage = () => {
        if (ulaCookie) {
            i18n.changeLanguage('cz');
        }
    }

    const handleSourceTextChange = (text) => {
        console.log('handleSourceTextChange', text);
        setCompareSourceText(sourceText);
    }

    const handleChapterSelect = (chapter) => {
        console.log('handleChapterSelect', chapter);
        setSelectedChapter(chapter);
    }

    const compareNormsAsync = async() => {
        setIsLoading(true);
        const result = await compareNorms(compareSourceText, selectedChapter);
        console.log('compareResult', result);
        setCompareResult(result);
        setSelectedTab(IntentEnum.SendQuestion);
        setIsLoading(false);     
    }

    const handleCompare = async () => {  
        compareNormsAsync();
        bottomRef.current.scrollIntoView({ behavior: "smooth" });
    }

    return (
        <>
        {isLoading && <LoadingScreen/> }
        <div id="mainContainer" className="page-container">
            <Grid container spacing={2} columnSpacing={4}>

                <Grid item xs={6} rowSpacing={3}>
                    <SourceText source={sourceText} onSubmit={(text) => handleSourceTextChange(text)}
                        onSourceTextChange={(text) => setSourceText(text)}/>

                    <Grid item xs={1} style={{ height: 40 }} />

                    <Grid item xs={12} className='compared-text-title'>
                        <h2 className='compared-text-heading'>{t('chapters.comparedText')}</h2>
                        <TextField className='compared-text-textfield' 
                            variant='standard'
                            multiline
                            fullWidth
                            rows={8}
                            value={comparedText}
                            InputProps={{
                            disableUnderline: true,
                            style: { 
                                fontSize: 14, 
                                borderRadius: 16, 
                                backgroundColor: 'white',
                                padding: 8
                            }}}
                        />
                    </Grid>

                    <button type="button" 
                            className="submit-button" 
                            onClick={handleCompare}
                            style={{display : !!sourceText && !!selectedChapter ? "block" : "none"}}
                            >{t('compareNorms')}
                            <span className="material-symbols-outlined">expand_more</span>
                    </button>
                </Grid>

                <Grid item xs={6} className='chapters-root-grid'>
                    <Chapters sourceText={compareSourceText} onChapterSelect={(chapter) => handleChapterSelect(chapter)}/>
                </Grid>

                {!!sourceText && !!selectedChapter && 
                <Grid item xs={12} ref={bottomRef}>
                    <ChatWindow chapter={selectedChapter} sourceText={sourceText} compareResult={compareResult}/>
                </Grid>}

            </Grid>
        </div>
        </>
    );

}
export default Page;
